
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpdateDetails = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.92 97.37a1.25 1.25 0 1 0 2.16 1.262l-1.08-.63-1.08-.631Zm80 1.263a1.25 1.25 0 0 0 2.159-1.262l-1.08.631-1.078.63ZM85.316 60.078a1.25 1.25 0 1 0-2.285-1.016l1.142.508 1.143.508Zm-21.833-35.59a1.25 1.25 0 1 0 .34-2.476l-.17 1.238-.17 1.238ZM20 98.001l1.08.631C29.105 84.896 43.94 76.428 60 76.428v-2.5c-16.939 0-32.599 8.931-41.08 23.443L20 98Zm40-22.823v1.25c16.06 0 30.894 8.468 38.92 22.205l1.08-.63 1.079-.632C92.599 82.86 76.939 73.928 60 73.928v1.25ZM84.172 59.57l-1.142-.508c-5.218 11.74-18.636 17.633-30.963 13.567l-.392 1.187-.391 1.187c13.53 4.463 28.283-1.995 34.03-14.925l-1.141-.508ZM51.676 73.816l.391-1.187c-12.322-4.064-19.465-16.73-16.51-29.207l-1.216-.288-1.217-.288c-3.259 13.76 4.625 27.693 18.16 32.157l.392-1.187ZM34.34 43.134l1.216.288C38.513 30.94 50.61 22.72 63.482 24.488l.17-1.238.17-1.238c-14.126-1.94-27.44 7.078-30.698 20.834l1.217.288Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M78.79 47.877h-7.161c-.66 0-1.194-.534-1.194-1.193v-6.666c0-.317.126-.62.35-.844l17.9-17.9a1.193 1.193 0 0 1 1.688 0l6.666 6.666a1.193 1.193 0 0 1 0 1.687l-18.25 18.25Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m83.943 26.016 8.354 8.354",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M18.9207 97.3706C18.5723 97.9666 18.7731 98.7322 19.3692 99.0805C19.9652 99.4288 20.7308 99.228 21.0791 98.632L19.9999 98.0013L18.9207 97.3706ZM98.9206 98.6328C99.269 99.2288 100.035 99.4296 100.631 99.0813C101.227 98.733 101.427 97.9675 101.079 97.3714L99.9999 98.0021L98.9206 98.6328ZM85.3147 60.0776C85.5951 59.4467 85.311 58.708 84.6802 58.4276C84.0493 58.1472 83.3106 58.4313 83.0302 59.0622L84.1725 59.5699L85.3147 60.0776ZM63.4823 24.4884C64.1662 24.5823 64.7968 24.104 64.8907 23.42C64.9846 22.7361 64.5063 22.1055 63.8223 22.0116L63.6523 23.25L63.4823 24.4884ZM19.9999 98.0013L21.0791 98.632C29.1064 84.8958 43.9402 76.4279 60.0001 76.4281L60.0001 75.1781L60.0001 73.9281C43.0612 73.9279 27.401 82.8592 18.9207 97.3706L19.9999 98.0013ZM60.0001 75.1781L60.0001 76.4281C76.0601 76.4283 90.8936 84.8964 98.9206 98.6328L99.9999 98.0021L101.079 97.3714C92.5991 82.8598 76.9391 73.9283 60.0001 73.9281L60.0001 75.1781ZM84.1725 59.5699L83.0302 59.0622C77.8117 70.8028 64.3938 76.6945 52.0671 72.6288L51.6755 73.8159L51.284 75.003C64.8141 79.4656 79.5675 73.0076 85.3147 60.0776L84.1725 59.5699ZM51.6755 73.8159L52.0671 72.6288C39.7451 68.5646 32.6016 55.8997 35.557 43.4219L34.3406 43.1338L33.1243 42.8457C29.8652 56.6057 37.7491 70.5387 51.284 75.003L51.6755 73.8159ZM34.3406 43.1338L35.557 43.4219C38.5134 30.9402 50.61 22.7209 63.4823 24.4884L63.6523 23.25L63.8223 22.0116C49.6959 20.0719 36.3825 29.0898 33.1243 42.8457L34.3406 43.1338Z\" fill=\"#000000\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M78.7891 47.8772H71.6289C70.9698 47.8772 70.4355 47.3429 70.4355 46.6838V40.0179C70.4355 39.7014 70.5613 39.3979 70.7851 39.1741L88.6855 21.2737C89.1515 20.8077 89.9071 20.8077 90.3731 21.2737L97.039 27.9396C97.505 28.4056 97.505 29.1612 97.039 29.6272L78.7891 47.8772Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M83.9434 26.016L92.2969 34.3695\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/update_details.212dbada0d67f55a1187a2a4da020cc5.svg"),
        {
          React: SvgUpdateDetails,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      